export const ACCENT = "#3D7BFF";

export const WEBINAR = {
  date: "SEPTEMBER 17TH",
  time: "7:00 PM",
  timezone: "EST",
  duration: "60 MINUTES",
  host: "Matthew Lake-Nestor",
  company: "Property Lending Team",
  nmls: "2050201",
  companyNmls: "1660690",
  states: "NC, SC, GA, FL, TX, TN, CO, IN",
  initials: "ML",
};

export const BONUSES = [
  "Free Live Webinar Access — The VA Home-Ready Blueprint",
  "VA Entitlement & Funding Fee Breakdown Guide (PDF)",
  "Same-Week Pre-Approval Scheduling Priority",
  "Closing-Cost & Concessions Checklist",
  "Optional Free VA Buyer Pre-Approval Strategy Call with Matthew",
];

export const FALSE_BELIEFS = [
  "\u201CI need a certain credit score before I can even start looking at homes.\u201D",
  "\u201CSellers won't choose a VA offer over a cash or conventional mortgage buyer.\u201D",
  "\u201CAll VA lenders are basically the same.\u201D",
];

export const AUDIENCE_CARDS = [
  { icon: "fa-solid fa-medal", text: "Veterans exploring homeownership for the first time" },
  { icon: "fa-solid fa-shield-halved", text: "Active-duty service members preparing to buy" },
  { icon: "fa-solid fa-house-chimney", text: "VA buyers comparing lenders who don't specialize in VA loans" },
  { icon: "fa-solid fa-rotate", text: "Veterans who've used their VA benefit before and aren't sure what's left" },
  { icon: "fa-solid fa-circle-question", text: "Anyone who's been told \u201Cnot yet\u201D by a lender who never explained why" },
];

export const MODULES = [
  {
    title: "VERIFY YOUR VA ELIGIBILITY",
    body: "How to confirm your VA eligibility and entitlement, in plain English — no jargon, no assumptions about your credit before you've even asked a question.",
  },
  {
    title: "KNOW YOUR ENTITLEMENT & FUNDING FEE",
    body: "A plain-language breakdown of what your VA entitlement actually covers, what the funding fee costs, and whether you may be exempt — including what remaining entitlement looks like if you've used your VA benefit before.",
  },
  {
    title: "SEE THE WHOLE DEAL",
    body: "Learn how your financing, the property, your offer, and the purchase contract all work together—and why strong communication between your Mortgage Loan Advisor and Realtor can make a meaningful difference throughout the transaction.",
  },
  {
    title: "WIN THE OFFER & PLAN THE CLOSE",
    body: "How VA buyers structure competitive offers, what seller concessions can realistically cover, and what a true 45–60 day closing timeline looks like — line by line, no surprises.",
  },
  {
    title: "YOUR NEXT STEP — ZERO PRESSURE",
    body: "What a same-week pre-approval conversation with Matthew looks like, what to bring, and how to get a clear answer on your VA eligibility and buying power within 7 days — no hard credit pull, no obligation.",
  },
];

export const TRANSFORMS = [
  "You'll know exactly what you qualify for and what your VA entitlement actually covers — no guessing.",
  "You'll understand your funding fee, whether you may be exempt, and what closing costs really look like.",
  "You'll have a same-week path to a clear answer — no hard credit pull, no pressure, no fine print surprises.",
];

export const TICKER_ITEMS = [
  "60 MINUTES", "5 CORE MODULES", "LIVE Q&A INCLUDED", "LICENSED IN 8 STATES",
  "NO COST TO ATTEND", "VA LOAN SPECIALIST", "LOAN ORIGINATOR & LICENSED REALTOR",
  "EDUCATIONAL · NOT A LOAN APPLICATION", "SEE THE WHOLE DEAL",
];

export const ROADMAP = [
  { num: "01", label: "STEP 01", name: "RESERVE", desc: "Lock in your free seat. Registration takes under a minute — no credit pull, no obligation." },
  { num: "02", label: "STEP 02", name: "WATCH", desc: "Join the live 60-minute session. Five modules, live Q&A, and every answer in plain English." },
  { num: "03", label: "STEP 03", name: "VERIFY", desc: "Confirm your VA eligibility and entitlement with a clear, same-week conversation — if you want one." },
  { num: "04", label: "STEP 04", name: "CLOSE", desc: "Move forward with a realistic offer plan and a line-by-line closing timeline. No surprises." },
];

export const TAKEAWAYS = [
  { icon: "fa-solid fa-map", title: "VA Entitlement & Funding Fee Breakdown", desc: "A plain-language guide to what your entitlement covers and what the funding fee actually costs." },
  { icon: "fa-solid fa-list-check", title: "Closing-Cost & Concessions Checklist", desc: "Every line item VA buyers should account for — and what sellers can realistically cover." },
  { icon: "fa-solid fa-comments", title: "Smarter Questions to Ask Any Lender", desc: "The exact questions that separate VA specialists from lenders who just tolerate VA loans." },
  { icon: "fa-solid fa-clipboard-check", title: "Your Next Step — Written and Clear", desc: "A concrete, zero-pressure path to a same-week answer on your eligibility and buying power." },
];

export const FAQS = [
  { q: "Is the webinar free?", a: "Yes. There is no cost to attend. This is an educational event." },
  { q: "Is this a loan application?", a: "No. Attending this webinar does not constitute a loan application and does not obligate you to apply for anything." },
  { q: "Will attending affect my credit?", a: "No. No credit pull is required to register or attend. If a credit review becomes relevant, Matthew will explain the process and obtain your consent before anything proceeds." },
  { q: "Who is this webinar for?", a: "Veterans, active duty service members, National Guard and Reserve members, and surviving spouses who have or may have VA home loan eligibility." },
  { q: "What will be covered?", a: "Five modules: verifying your VA eligibility, understanding your entitlement and funding fee, how the lender-realtor vertical review works, how to win a competitive offer and plan a realistic close, and your same-week next step." },
  { q: "Is it live or on demand?", a: "This is a live session on September 17th at 7:00 PM EST. A replay may be available — details will be shared after registration." },
  { q: "What happens after I register?", a: "You will receive a confirmation with event access details, along with the VA Entitlement & Funding Fee Breakdown Guide and Closing-Cost Checklist ahead of the session." },
  { q: "Do I have to speak with a loan officer afterward?", a: "Absolutely not. Attending the webinar does not require a follow-up conversation. If a free VA Buyer Pre-Approval Strategy Call would be useful, that option is available — but it's entirely optional and has no commitment attached." },
];

export const COMPLIANCE_DISCLOSURE = "This is an educational webinar. Attendance does not constitute a loan application or commitment to lend. No credit pull is required to attend. VA loan eligibility requires qualifying military service and is subject to lender, property, and program requirements. The VA funding fee may be waived for veterans with qualifying service-connected disability ratings — consult the VA directly for your eligibility status. All loans are subject to borrower qualification, credit review, property approval, program guidelines, and underwriting requirements. Matthew Lake-Nestor is licensed as both a real estate agent and a loan originator; [[COMPLIANCE/LEGAL TO REVIEW AND INSERT REQUIRED DUAL-CAPACITY / AFFILIATED-BUSINESS DISCLOSURE LANGUAGE HERE — RESPA Section 8 disclosure requirements likely apply; do not launch without compliance sign-off on this specific point]]. Program availability and terms may vary. Content is for educational purposes only and is not financial or legal advice. Matthew Lake-Nestor NMLS# 2050201 · Nexa Lending NMLS# 1660690 · Licensed in NC, SC, GA, FL, TX, TN, CO, IN. Equal Housing Lender.";

export const CONSENT_TEXT = "By checking this box, I consent to receive communications about the VA Home-Ready Blueprint webinar from Matthew Lake-Nestor / Nexa Lending via email, phone, and SMS at the contact information provided. Message and data rates may apply. Consent is not a condition of any purchase or loan. I can opt out at any time.";
